export default __webpack_public_path__ + "static/media/038-walkie-talkie.f0d9d6c0.png";